import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { changeCustomFieldFilters } from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';

import CustomFieldFilters from 'bundles/apex/custom_fields/filters/filters';
import { filterByTab } from './helpers';

import type { Filters } from 'bundles/apex/custom_fields/filters/types';

export default function CompsCustomFieldFilters() {
  const features: Record<string, boolean> = useSelector((state: any) => state.features);
  const filters: Filters = useSelector((state: any) => state.query.customFieldFilters) || {};
  const currentTab: string = useSelector((state: any) => state.ui.currentTab);
  const schemas = useSelector((state: any) => state.customFieldSchemas);
  const dispatch = useDispatch();
  
  function changeFilter(filter: Partial<Filters>) {
    dispatch(changeCustomFieldFilters(filter));
    dispatch(delayRetrieveRecords());
  }

  if (!features.edgeCrm || !schemas.length) {
    return null;
  }

  return (
    <CustomFieldFilters
      changeFilter={changeFilter}
      filterFunction={filterByTab(currentTab)}
      filters={filters}
      schemas={schemas}
    />
  );
}
